import React, { useMemo } from 'react';

import {
  createScreenRoute,
  BreadcrumbProvider,
  SearchParamsStorage,
} from '@gogame/screens';
import { Route, useParams } from '@gogame/screens';
import { Sentry } from '@gogame/components';
import MarketingPlanningGrid from './MarketingPlanningGrid';
import MarketingPlanningForm from './MarketingPlanningWizard/MarketingPlanningForm';
import MarketingPlanningPreview from './MarketingPlanningWizard/MarketingPlanningPreview';
import LoaderProvider from './MarketingPlanningWizard/components/Loader';
import {
  marketingPlanningBaseLink,
  marketingPlanningGridLink,
  marketingPlanningPreviewLink,
  marketingPlanningWizardLink,
  marketingPlanningGridScreenSchema,
  marketingPlanningWizardScreenSchema,
  marketingPlanningPreviewScreenSchema,
} from './navigation';
import { formatPlanName } from './utils';

const id = 47;
const permission = 58;

const GridScreen = () => {
  return (
    <SearchParamsStorage searchParams={marketingPlanningGridScreenSchema}>
      <MarketingPlanningGrid />
    </SearchParamsStorage>
  );
};

const PreviewScreen = () => {
  const { year, month } = useParams();

  const version = useMemo(() => {
    let matchResult =
      window.document.location.search.match(/\?version=([\d.]+)/);
    return matchResult?.[1];
  }, [window.document.location]);

  const title = useMemo(() => {
    return formatPlanName({ year, month, version });
  }, [year, month, version]);

  return (
    <SearchParamsStorage searchParams={marketingPlanningPreviewScreenSchema}>
      <BreadcrumbProvider title={title}>
        <LoaderProvider>
          <MarketingPlanningPreview />
        </LoaderProvider>
      </BreadcrumbProvider>
    </SearchParamsStorage>
  );
};

const WizardScreen = () => {
  const { year, month } = useParams();
  const title = useMemo(() => {
    return formatPlanName({ year, month });
  }, [year, month]);

  return (
    <SearchParamsStorage searchParams={marketingPlanningWizardScreenSchema}>
      <BreadcrumbProvider title={title}>
        <LoaderProvider>
          <MarketingPlanningForm />
        </LoaderProvider>
      </BreadcrumbProvider>
    </SearchParamsStorage>
  );
};

const MarketingPlanning = () => {
  return (
    <Sentry.Routes>
      <Route
        path={`${marketingPlanningGridLink.path}`}
        element={<GridScreen />}
      />
      <Route
        path={`${marketingPlanningPreviewLink.path}/*`}
        element={<PreviewScreen />}
      />
      <Route
        path={`${marketingPlanningWizardLink.path}/*`}
        element={<WizardScreen />}
      />
    </Sentry.Routes>
  );
};

export default createScreenRoute({
  id: id,
  title: 'Planning',
  link: marketingPlanningBaseLink,
  screen: <MarketingPlanning />,
  permission: permission,
  knowledgeBaseUrl:
    'https://go-game.zendesk.com/hc/en-us/articles/360012073414-Marketing-Planning',
});
